import CenterText from './chart-doughnut-center-text-plugin';
import cloneDeep from 'lodash.clonedeep';

const BG_COLORS = ["#5BAED9", "#FC9A38", "#D54894", '#8C4646', '#50A082'];

const INIT_OPTIONS = {
    type: 'doughnut',
    options: {
        events: [], //disabilita le interazioni (hover, click ...)
        responsive: true,
        maintainAspectRatio: false,
        
        borderWidth:0,
        plugins: {
            title: {
                display: true,
                padding : {
                    bottom:25
                },
                text: '',
                color: '#000',
                textAlign: 'left',
                font: {
                    size: 14,
                    family: "'Work Sans', sans-serif",
                    weight:"500"
                }
            },
            legend: {
                title: {
                    display: true,
                    padding:{
                        top:25
                    },
                    text: '',
                    color: '#000',
                    textAlign: 'left',
                    font: {
                        size: 14,
                        family: "'Work Sans', sans-serif",
                        weight: "500"
                    }
                },
                position: 'bottom',
                labels: {
                    align:"end",
                    color: '#000',
                    usePointStyle: true,
                    boxWidth:10,
                    font: {
                        size: 14,
                        family: "'Work Sans', sans-serif",
                        weight: "500"
                    }
                }
            },
            tooltip: {
                enabled: false
            },
            datalabels: {
                color: 'white',
                display: function(context) {
                    var dataset = context.dataset;
                    var count = dataset.data.length;
                    var value = dataset.data[context.dataIndex];
                    //console.log('---', { dataset, count, value });
                    return value > 0; //count * 1.5;
                },
                font: {
                    weight: 'bold',
                    family: "'Work Sans', sans-serif"                
                },
                textAlign: 'center',
                padding: 6,
                formatter: function(value, context) {
                    return value;
                }
            }
        },
        elements: {
            centerText: {
                text: '',
                color: '#000', // Default is #000000
                fontStyle: "'Work Sans', sans-serif", // Default is Arial
                sidePadding: 20, // Default is 20 (as a percentage)
                minFontSize: 24, // Default is 20 (in px), set to false and text will not wrap.
                lineHeight: 25, // Default is 25 (in px), used for when text wraps
            }
        }
    },
    data: {
        datasets: [
            {
                backgroundColor: [],
                datalabels: {
                    anchor: 'center'
                }
            }
        ]
    },
    dataType: 'euroM',
    dataTypes: {
        euroM: {
            valueFormat: { pre: '€', post: 'M' }
        },
        perc: {
            valueFormat: { post: '%' }
        }
    },
    calcPerc: false
}

class ABChartDoughnutCore {
    target;
    targetObj;
    options;
    plugin;

    constructor(target, options) {
        this.target = target;
        this.targetObj = this.getTarget(target);
        this.options = this.getOptions(options);
        this.handleOptions();
    }

    getOptions(options) {        
        const newOpt = Object.assign({}, cloneDeep(INIT_OPTIONS), options);
        return newOpt;
    }
    getTarget(target) {
        return document.querySelector(target);
    }

    handleOptions() {
        if (this.options.title) {
            this.options.options.plugins.title.text = this.options.title;
        }
        if (this.options.titleLegend) {
            this.options.options.plugins.legend.title.text = this.options.titleLegend;
        }
        if (this.options.centerText) {
            this.options.options.elements.centerText.text = this.options.centerText;
        }
        if (this.options.labels) {
            this.options.data.labels = this.options.labels;
        }
        if (this.options.values) {
            this.options.data.datasets[0].data = this.options.values;
            this.options.data.datasets[0].backgroundColor = this.getBgColors(this.options.values.length);
        }
        this.options.options.plugins.datalabels.formatter = this.getFormatter(this.options.dataType);
    }

    getBgColors(colorNum) {
        /*const endIdx = colorNum < BG_COLORS.length ? colorNum : BG_COLORS.length -1;
        const result = [];
        for (let i=0; i<=endIdx; i++) {
            result.push(BG_COLORS[i]);
        }*/
        return this.options.colors ? this.options.colors : BG_COLORS;
    }

    render() {
        if (!this.plugin) {
            var ctx3 = this.targetObj.getContext('2d');
            this.options.plugins = [
                window.ChartDataLabels,
                CenterText
            ];            
            this.plugin = new Chart(ctx3, this.options);
        }
    }

    destroy() {

    }

    refresh(options) {
        this.options = this.getOptions(options);
        this.handleOptions();

        this.plugin.options = this.options.options;
        this.plugin.data = this.options.data;
        this.plugin.update();
    }

    getFormatter(dataType) {
        const data = this.options.dataTypes[dataType] && this.options.dataTypes[dataType].valueFormat || {};
        return (value, context) => {           
            //console.log('---', { value, context, calcPerc: this.options.calcPerc, opt: this.options });
            return [
                (data.pre ? data.pre : '') + value + (data.post ? data.post : '')                
            ].concat(this.options.calcPerc ? [this.getPercValue(value, context)] : []); //per evitare che stampi una riga vuota
        }
    }
    getPercValue(value, context) {
        let total = 0;
        context.dataset.data.forEach((val) => total += val);

        return '(' + parseFloat((100 * value) / total).toFixed(1) + '%)';
    }
}

class ABChartDoughnut {
    core;
    constructor(target, options) {
        this.core = new ABChartDoughnutCore(target, options);
    }

    render() {
        this.core.render();
    }

    refresh(options) {
        this.core.refresh(options);
    }
}

window.ABChartDoughnut = ABChartDoughnut;

export default ABChartDoughnut;